export default "__VITE_ASSET__BPsT_UpI__"